export type ApplicationType = 'epe' | 'service1' | 'service2' | 'service3';
export type ApplicationStatus = 'draft' | 'pending' | 'eligible' | 'not_eligible' | 'voted' | 'proactive';

export interface DrupalUserInfo {
  username?: string
  name?: string
  surname?: string
  email?: string
  organisation?: string
  organisation_type?: string
  gender?: string
  country?: string
  phone_number?: string
  picture?: string
  [key: string]: any
}

export class Application {
  [index: string]: any
  _id?: string
  user_id?: number
  application_type?: ApplicationType
  status?: ApplicationStatus
  form_data?: EpeFormData | ProjectFormData
  user_info?: DrupalUserInfo
  created_at?: string
  updated_at?: string
}

export interface PreviousPosition {
  from?: string
  to?: string
  employer?: string
  position_held?: string
}

export interface AcademicQualification {
  from?: string
  to?: string
  higher_education_qualification?: string
  academic_qualification?: string
}

export interface StandardisationRole {
  sdo?: string
  other_sdo?: string
  tc_number?: string
  tc_title?: string
  roles?: string
  years_of_experience?: string
}

export interface EpeTopicEntry {
  value: string;                   // topic id from epe-topics.TOPIC_GROUPS
  evidence_of_expertise: string;   // required, max 1000 chars
  primary_support_types: string[]; // multi-select, >= 1 value
}

export const SUPPORT_TYPE_OPTIONS: string[] = [
  'Standardisation landscape analysis',
  'Standards gap analysis',
  'Standardisation roadmapping',
  'SDO and technical committee mapping',
  'Contribution drafting',
  'Liaison strategy',
  'Harmonised standards and conformity advice',
  'Standardisation training',
  'Exploitation and valorisation advice',
];

export class EpeFormData {
  [index: string]: any
  topics?: EpeTopicEntry[] = []
  position?: string
  position_start_date?: string
  previous_positions?: PreviousPosition[] = []
  academic_qualifications?: AcademicQualification[] = []
  standardisation_experience?: string
  sdo_member?: string
  standardisation_roles?: StandardisationRole[] = []
  fit_support_approach?: string
  fit_ri_experience?: string
  fit_knowledge_valorisation?: string
  fit_additional_expertise?: string
  availability?: string
  preferred_services?: string[] = []
  working_languages?: string[] = []
  time_zone?: string
  availability_limitations?: string
  cv?: string
  confidentiality_declaration?: boolean
  accuracy_declaration?: boolean
  data_protection_consent?: boolean
  public_profile_consent?: string
  newsletter_subscription?: string
  // legacy (older applications / other views)
  linkedin?: string
  tell_us_more?: string
  website_publication?: boolean
}

export class ProjectFormData {
  [index: string]: any
  // Q1
  funding_type?: string
  project_acronym?: string
  full_project_name?: string
  funding_programme?: string
  other_funding_programme?: string
  national_programme_name?: string
  national_programme_country?: string
  grant_agreement?: string
  project_call_topic_id?: string
  coordinator_country?: string
  project_website?: string
  project_officer_name?: string
  project_officer_email?: string
  // Q3
  topics?: string[] = []
  information_to_attain?: string[] = []
  other_support_specification?: string
  project_short_description?: string
  why_the_project_applying?: string
  // Q4
  support_start?: string
  support_milestone?: string
  cluster_support?: string
  cluster_details?: string
  // Q5
  know_standards?: string
  standards_details?: string
  standard_reference?: object[] = []
  // Q6
  preferred_languages?: string
  time_zone?: string
  scheduling_constraints?: string
  // Q7
  website_publication?: boolean
  data_consent?: boolean
  accuracy_declaration?: boolean
  // legacy
  objectives_standardisation?: string
  related_doc_application?: object[] = []
  title?: string
  organisation?: string
  country?: string
  // PSS (service2) only — Q2
  support_expectations?: string
  trl_start?: string
  trl_target?: string
  applicable_regulations?: string
  call_deadline?: string
  one_pager_file_id?: string
  one_pager_filename?: string
  // PSS (service2) only — Q3
  nsb_contact?: string
  nsb_contact_name?: string
  known_standards_yn?: string
  known_standards_titles?: string
}

export const APPLICATION_TYPE_LABELS: Record<ApplicationType, string> = {
  epe: 'EPE Application',
  service1: 'Mentoring',
  service2: 'Proposal Support Service',
  service3: 'Service 3',
};

export const STATUS_COLORS: Record<ApplicationStatus, string> = {
  draft: '#95a5a6',
  pending: '#f39c12',
  eligible: '#2ecc71',
  not_eligible: '#e74c3c',
  voted: '#3498db',
  proactive: '#9b59b6',
};
